import { render } from "./BankRecs.vue?vue&type=template&id=7b98a9ce&scoped=true"
import script from "./BankRecs.vue?vue&type=script&lang=js"
export * from "./BankRecs.vue?vue&type=script&lang=js"

import "./BankRecs.vue?vue&type=style&index=0&id=7b98a9ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b98a9ce"]])

export default __exports__